export enum AgreementType {
    CheckInTerms = 'CheckInTerms',
    PrivacyPolicy = 'PrivacyPolicy',
    RiskResponsibility = 'RiskResponsibility',
}

export interface Agreement {
    id: string;
    tenantId: string;
    branchId?: string;
    title: string;
    type: AgreementType;
    content: string;
    version: string;
    effectiveDate: Date;
    expirationDate?: Date;
    isActive: boolean;
    internalNotes?: string;
    createdDate: Date;
    updatedDate: Date;
    deletedDate?: Date;
}
